// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.configure_deploy_env_modal__body {
    display: flex;
    flex-direction: column;
    gap: 0;
    margin: -11px 0 0;
}

/* ── Empty state ── */

.configure_deploy_env_modal__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 28px 0 12px;
}

.configure_deploy_env_modal__empty_btn {
    padding: 7px 18px;
    font-size: 13px;
    border-radius: 4px;
    border: 1px solid var(--color-border);
    background: var(--color-bg-3);
    color: var(--color-text);
    cursor: pointer;
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .configure_deploy_env_modal__empty_btn:hover {
        background: var(--color-border);
    }
}

/* ── Tabs bar ── */

.configure_deploy_env_modal__tabs_bar {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    background-color: var(--color-bg-1, var(--color-bg));
    border-bottom: 1px solid var(--color-border);
    overflow-x: auto;
    scrollbar-width: none;
    margin: 0 -18px;
}

.configure_deploy_env_modal__tabs_bar::-webkit-scrollbar {
    display: none;
}

.configure_deploy_env_modal__tab {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 14px;
    height: 36px;
    border-bottom: 2px solid transparent;
    color: var(--color-text-muted);
    font-size: 13px;
    cursor: pointer;
    user-select: none;
    transition: color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .configure_deploy_env_modal__tab:hover {
        color: var(--color-text);
    }
}

.configure_deploy_env_modal__tab.active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent);
}

.configure_deploy_env_modal__tab_label {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
    white-space: nowrap;
}

.configure_deploy_env_modal__tab_close {
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    font-size: 15px;
    line-height: 1;
    opacity: 0;
    transition: opacity 0.1s, background-color 0.1s;
}

.configure_deploy_env_modal__tab:hover .configure_deploy_env_modal__tab_close,
.configure_deploy_env_modal__tab.active .configure_deploy_env_modal__tab_close {
    opacity: 0.6;
}

@media (pointer: fine) {
    .configure_deploy_env_modal__tab_close:hover {
        opacity: 1 !important;
        background-color: var(--color-bg-3);
    }
}

@media (hover: none) {
    .configure_deploy_env_modal__tab_close {
        opacity: 0.6;
    }
}

.configure_deploy_env_modal__new_tab_btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: none;
    border: none;
    color: var(--color-text-muted);
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .configure_deploy_env_modal__new_tab_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

/* ── Form ── */

.configure_deploy_env_modal__form {
    display: flex;
    flex-direction: column;
    gap: 11px;
    padding-top: 14px;
}

.configure_deploy_env_modal__field {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.configure_deploy_env_modal__field_label {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--color-text-muted);
}

.configure_deploy_env_modal__field_hint {
    font-size: 12px;
    color: var(--color-text-muted);
    margin: 0;
    padding: 6px 0;
}

.configure_deploy_env_modal__section_title {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--color-text-muted);
    padding-top: 6px;
    border-top: 1px solid var(--color-border);
    margin-top: 2px;
}

/* ── Footer actions ── */

.configure_deploy_env_modal__actions {
    display: flex;
    justify-content: flex-end;
    gap: 9px;
}

.configure_deploy_env_modal__btn {
    padding: 6px 15px;
    font-size: 13px;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.15s;
}

.configure_deploy_env_modal__btn--cancel {
    color: var(--color-text);
    background-color: var(--color-bg-3);
}

@media (pointer: fine) {
    .configure_deploy_env_modal__btn--cancel:hover {
        background-color: var(--color-border);
    }
}

.configure_deploy_env_modal__btn--save {
    color: #fff;
    background-color: var(--color-accent);
}

@media (pointer: fine) {
    .configure_deploy_env_modal__btn--save:hover {
        background-color: var(--color-accent-hover);
    }
}
`, "",{"version":3,"sources":["webpack://./components/ConfigureDeploymentEnvModal/s.configure_deploy_env_modal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,iBAAiB;AACrB;;AAEA,sBAAsB;;AAEtB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,6BAA6B;IAC7B,wBAAwB;IACxB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ;;AAEA,mBAAmB;;AAEnB;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,oDAAoD;IACpD,4CAA4C;IAC5C,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,oCAAoC;IACpC,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,UAAU;IACV,+CAA+C;AACnD;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI;QACI,qBAAqB;QACrB,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;AACnB;;AAEA,yBAAyB;;AAEzB;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ","sourcesContent":[".configure_deploy_env_modal__body {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    margin: -11px 0 0;\n}\n\n/* ── Empty state ── */\n\n.configure_deploy_env_modal__empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 28px 0 12px;\n}\n\n.configure_deploy_env_modal__empty_btn {\n    padding: 7px 18px;\n    font-size: 13px;\n    border-radius: 4px;\n    border: 1px solid var(--color-border);\n    background: var(--color-bg-3);\n    color: var(--color-text);\n    cursor: pointer;\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .configure_deploy_env_modal__empty_btn:hover {\n        background: var(--color-border);\n    }\n}\n\n/* ── Tabs bar ── */\n\n.configure_deploy_env_modal__tabs_bar {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    background-color: var(--color-bg-1, var(--color-bg));\n    border-bottom: 1px solid var(--color-border);\n    overflow-x: auto;\n    scrollbar-width: none;\n    margin: 0 -18px;\n}\n\n.configure_deploy_env_modal__tabs_bar::-webkit-scrollbar {\n    display: none;\n}\n\n.configure_deploy_env_modal__tab {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 0 14px;\n    height: 36px;\n    border-bottom: 2px solid transparent;\n    color: var(--color-text-muted);\n    font-size: 13px;\n    cursor: pointer;\n    user-select: none;\n    transition: color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .configure_deploy_env_modal__tab:hover {\n        color: var(--color-text);\n    }\n}\n\n.configure_deploy_env_modal__tab.active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent);\n}\n\n.configure_deploy_env_modal__tab_label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 120px;\n    white-space: nowrap;\n}\n\n.configure_deploy_env_modal__tab_close {\n    flex-shrink: 0;\n    width: 15px;\n    height: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1;\n    opacity: 0;\n    transition: opacity 0.1s, background-color 0.1s;\n}\n\n.configure_deploy_env_modal__tab:hover .configure_deploy_env_modal__tab_close,\n.configure_deploy_env_modal__tab.active .configure_deploy_env_modal__tab_close {\n    opacity: 0.6;\n}\n\n@media (pointer: fine) {\n    .configure_deploy_env_modal__tab_close:hover {\n        opacity: 1 !important;\n        background-color: var(--color-bg-3);\n    }\n}\n\n@media (hover: none) {\n    .configure_deploy_env_modal__tab_close {\n        opacity: 0.6;\n    }\n}\n\n.configure_deploy_env_modal__new_tab_btn {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    background: none;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .configure_deploy_env_modal__new_tab_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n/* ── Form ── */\n\n.configure_deploy_env_modal__form {\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n    padding-top: 14px;\n}\n\n.configure_deploy_env_modal__field {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.configure_deploy_env_modal__field_label {\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n}\n\n.configure_deploy_env_modal__field_hint {\n    font-size: 12px;\n    color: var(--color-text-muted);\n    margin: 0;\n    padding: 6px 0;\n}\n\n.configure_deploy_env_modal__section_title {\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n    padding-top: 6px;\n    border-top: 1px solid var(--color-border);\n    margin-top: 2px;\n}\n\n/* ── Footer actions ── */\n\n.configure_deploy_env_modal__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 9px;\n}\n\n.configure_deploy_env_modal__btn {\n    padding: 6px 15px;\n    font-size: 13px;\n    border-radius: 3px;\n    cursor: pointer;\n    transition: background-color 0.15s;\n}\n\n.configure_deploy_env_modal__btn--cancel {\n    color: var(--color-text);\n    background-color: var(--color-bg-3);\n}\n\n@media (pointer: fine) {\n    .configure_deploy_env_modal__btn--cancel:hover {\n        background-color: var(--color-border);\n    }\n}\n\n.configure_deploy_env_modal__btn--save {\n    color: #fff;\n    background-color: var(--color-accent);\n}\n\n@media (pointer: fine) {\n    .configure_deploy_env_modal__btn--save:hover {\n        background-color: var(--color-accent-hover);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
